import React from 'react';

import CustomTable from '../../../components/CustomTable';

import './styles.css'

export default function ResultList(props) {
    return (
        <CustomTable
            className={'table-reporte-registro-venta'}
            pagination={props.pagination}
            loadingExcel={props.loadingExcel}
            loadingPdf={props.loadingPdf}
            loadingPdfRegistrado={props.loadingPdfRegistrado}
            loadingPLE={props.loadingPLE}
            onExportExcel={props.onExportExcel}
            onExportPdf={props.onExportPdf}
            onExportPLE={props.onExportPLE}
            onExportPdfRegistrado={props.onExportPdfRegistrado}
            onPrint={props.onPrint}
            onChange={props.onChange}
            rowKey={record => record.id}
            columns={[
                {
                    title: 'Fecha de emisión del comprobante de pago o documento',
                    dataIndex: 'fechaEmisionStr',
                    key: 'fechaEmisionStr',
                    sorter: true
                },
                {
                    title: 'Fecha de vencimiento y/o pago',
                    dataIndex: 'fechaVencimientoStr',
                    key: 'fechaVencimientoStr',
                    sorter: true
                },
                {
                    title: 'Comprobante de pago o documento',
                    className: 'parent-group',
                    children: [
                        {
                            title: 'Tipo(10)',
                            dataIndex: 'tipo',
                            key: 'tipo',
                            className: 'child-group',
                            sorter: true
                        },
                        {
                            title: 'Nº serie o Nº de serie de la máquina registrada',
                            dataIndex: 'serie',
                            key: 'serie',
                            className: 'child-group',
                            sorter: true
                        },
                        {
                            title: 'Número',
                            dataIndex: 'numero',
                            key: 'numero',
                            className: 'child-group',
                            sorter: true
                        }
                    ]
                },
                {
                    title: 'Información del Cliente',
                    className: 'parent-group parent-group-2',
                    children: [
                        {
                            title: 'Tipo',
                            dataIndex: 'documento',
                            key: 'documento',
                            className: 'child-group',
                            sorter: true
                        },
                        {
                            title: 'Número',
                            dataIndex: 'ruc',
                            key: 'ruc',
                            className: 'child-group',
                            sorter: true
                        },
                        {
                            title: 'Apellidos y nombres denominación o razón social',
                            dataIndex: 'razonSocial',
                            key: 'razonSocial',
                            className: 'child-group child-group-2',
                            sorter: true,
                            render: (value) => (
                                <div style={{ minWidth: "300px" }}>{value}</div>
                            )
                        }
                    ]
                },
                {
                    title: 'Valor facturado de la exportación',
                    dataIndex: 'valorFacturadoExportacionStr',
                    key: 'valorFacturadoExportacionStr',
                    align: 'right',
                    sorter: true
                },
                {
                    title: 'Base imponible de la operación gravada',
                    dataIndex: 'baseImponibleStr',
                    key: 'baseImponibleStr',
                    align: 'right',
                    sorter: true
                },
                {
                    title: 'Importe total de la operación exonerada o inafecta',
                    className: 'parent-group parent-group-2',
                    children: [
                        {
                            title: 'Exonerada',
                            dataIndex: 'exoneradaStr',
                            key: 'exoneradaStr',
                            align: 'right',
                            className: 'child-group',
                            sorter: true
                        },
                        {
                            title: 'Inafecta',
                            dataIndex: 'inafectaStr',
                            key: 'inafectaStr',
                            align: 'right',
                            className: 'child-group child-group-2',
                            sorter: true
                        }
                    ]
                },
                {
                    title: 'Operación Grabada con el IVAP',
                    className: 'parent-group parent-group-2',
                    children: [
                        {
                            title: 'Base Imponible',
                            dataIndex: 'baseImponibleIVAPStr',
                            key: 'baseImponibleIVAPStr',
                            align: 'right',
                            className: 'child-group',
                            sorter: true
                        },
                        {
                            title: 'IVAP',
                            dataIndex: 'impuestoIVAPStr',
                            key: 'impuestoIVAPStr',
                            align: 'right',
                            className: 'child-group child-group-2',
                            sorter: true
                        }
                    ]
                },
                {
                    title: 'ISC',
                    dataIndex: 'iscStr',
                    key: 'iscStr',
                    align: 'right',
                    sorter: true
                },
                {
                    title: 'IGV y/o IPM',
                    dataIndex: 'igvStr',
                    key: 'igvStr',
                    align: 'right',
                    sorter: true
                },
                {
                    title: 'ICBPER',
                    dataIndex: 'icbperStr',
                    key: 'icbperStr',
                    align: 'right',
                    sorter: true
                },
                {
                    title: 'Otros tributos y cargos que no forman parte de la base imponible',
                    dataIndex: 'otrosTributosStr',
                    key: 'otrosTributosStr',
                    align: 'right',
                    sorter: true
                },
                {
                    title: 'Importe total del comprobante de pago',
                    dataIndex: 'totalStr',
                    key: 'totalStr',
                    align: 'right',
                    sorter: true
                },
                {
                    title: 'Tipo de cambio',
                    dataIndex: 'tipoCambioStr',
                    key: 'tipoCambioStr',
                    align: 'right',
                    sorter: true
                },
                {
                    title: 'Referencia del comprobante de pago o documento original que se modifica',
                    className: 'parent-group',
                    children: [
                        {
                            title: 'Fecha',
                            dataIndex: 'fechaStr',
                            key: 'fechaStr',
                            align: 'center',
                            className: 'child-group',
                            sorter: true
                        },
                        {
                            title: 'Tipo (Tabla 10)',
                            dataIndex: 'tipoReferencia',
                            key: 'tipoReferencia',
                            className: 'child-group',
                            sorter: true
                        },
                        {
                            title: 'Serie',
                            dataIndex: 'serieReferencia',
                            key: 'serieReferencia',
                            className: 'child-group',
                            sorter: true
                        },
                        {
                            title: 'Nº del comprobante de pago o documento',
                            dataIndex: 'comprobantePagoReferencia',
                            key: 'comprobantePagoReferencia',
                            className: 'child-group',
                            sorter: true
                        }
                    ]
                }
            ]}
        />
    );
}